import { useRef, useLayoutEffect } from 'react';
import isNumber from 'lodash/isNumber';
export default function useSelectionRange(_ref) {
  var inputElement = _ref.inputElement,
    inputValue = _ref.inputValue,
    forceUpdate = _ref.forceUpdate;
  var refSelectionPosition = useRef();
  useLayoutEffect(function () {
    var position = refSelectionPosition.current;
    if (inputElement && inputValue && isNumber(position)) {
      var start = Math.max(0, inputValue.length - position);
      inputElement.setSelectionRange(start, start);
    }
  }, [inputValue, forceUpdate]);
  return function (event) {
    var _event$target = event.target,
      end = _event$target.selectionEnd,
      value = _event$target.value;
    if (isNumber(end)) {
      refSelectionPosition.current = value.length - end;
    }
  };
}